import { Claimant, StoplossClaim, TargetSchema, ValidAny } from "@/types";

// Schema label mapping for display
export const SCHEMA_LABELS: Record<TargetSchema, string> = {
  [TargetSchema.CLAIMANT]: "Claimants",
  [TargetSchema.CLAIM_ITEM]: "Claims",
  [TargetSchema.STOPLOSS_CLAIM]: "Stop-Loss Claims",
  [TargetSchema.CLIENT]: "Clients",
  [TargetSchema.REIMBURSEMENT]: "Reimbursements",
  [TargetSchema.POLICY]: "Policies",
};

// Type guards for extracted record data
export const isClaimantData = (data: ValidAny): data is Claimant => {
  return data && ("claimant_first_name" in data || "claimant_last_name" in data || "claimant_name" in data);
};

export const isStoplossClaimData = (data: ValidAny): data is StoplossClaim => {
  return data && "stoploss_claim_data" in data;
};

// Helper to get claimant display name
export const getClaimantName = (data: Claimant): string => {
  if (!isClaimantData(data)) return "Unknown";
  return data.claimant_name || `${data.claimant_first_name || ""} ${data.claimant_last_name || ""}`.trim() || "Unknown";
};
